<template lang="html">
	<button
		ref="el"
		v-bind="$attrs"
		type="submit"
		class="omapi-button omapi-wizard-forward omapi-button__green"
		:disabled="disabled"
		v-on="$listeners"
	>
		{{ text }}
	</button>
</template>
<script lang="js">
export default {
	props : {
		disabled : Boolean,
		text     : {
			type    : String,
			default : 'Next Step',
		},
	},
};
</script>
